import { useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { MarginsPanel } from "@/components/pricing/MarginsPanel";
import { GiftTiersPanel } from "@/components/pricing/GiftTiersPanel";

export function PricingRules({ onSaved }) {
  return (
    <div className="grid xl:grid-cols-5 gap-6 items-start" data-testid="pricing-rules">
      <div className="xl:col-span-2"><MarginsPanel onSaved={onSaved} /></div>
      <div className="xl:col-span-3"><GiftTiersPanel onSaved={onSaved} /></div>
    </div>
  );
}

export function PricingRulesSheet({ onSaved }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="open-pricing-rules-button">
        <SlidersHorizontal className="h-4 w-4 mr-2" />Pricing rules
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:max-w-3xl overflow-y-auto" data-testid="pricing-rules-sheet">
          <SheetHeader className="mb-5">
            <SheetTitle>Pricing rules</SheetTitle>
            <SheetDescription>Global margins and gift tiers used by every quotation. Changes apply immediately.</SheetDescription>
          </SheetHeader>
          <div className="space-y-6">
            <MarginsPanel onSaved={onSaved} />
            <GiftTiersPanel onSaved={onSaved} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
